import { AxiosRequestConfig } from "axios";

import { API_BASE_URLS } from "./apiConfig";

export type TApiMethod = "POST" | "GET" | "PATCH" | "DELETE";

export type TApiStatus = "failed" | "success";
export interface IApiErrorData {
  message: string;
  status: TApiStatus;
  statusCode: number;
  error: boolean;
}

export interface IApiResponseData<T> {
  error: boolean;
  statusCode: number;
  message: string;
  data: T;
}

export interface IApiCallPayload {
  apiRoute: string;
  module: keyof typeof API_BASE_URLS;
  config: AxiosRequestConfig;
  useEncryption: boolean;
}

export enum API_ERROR_MESSAGES {
  NETWORK_ERROR = "Network error! Please try again later.",
  INTERNAL_SERVER_ERROR = "Internal server error!",
  NO_SERVER_RESPONSE = "Service unavailable! Please retry in a few minutes.",
  NOT_AUTHORIZED = "You are not authorized to access this!",
  PERMISSION_ERROR = "You do not have permission to access this resource",
}

export interface IApiErrorDetails {
  url: string;
  status: number;
  data: IApiResponseData<any>;
}
